import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=cd4d9e12"
import script from "./SystemMessage.vue?vue&type=script&lang=ts"
export * from "./SystemMessage.vue?vue&type=script&lang=ts"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&id=cd4d9e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports